import React from 'react'
import Base from './Base'

export default props => (
  <Base {...props}>
    <path d='M2.5,2.5v95h95v-95H2.5z M43.6,72L26.1,49.3l5.2-4l12.3,16l25.1-32.6l5.2,4L43.6,72z' />
  </Base>
)
